import { getMcAppFromBaseProps } from "../lib/baseProps";
import { IBaseProps, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const createRefundsMcApp = ({ name, ...props }: IBaseProps): IMcAppType[] => {
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/refunds",
      intent: name,
    }),
  ];
};

const refundsApp: IBaseProps[] = [
  {
    name: "refunds",
    path: "",
    subPath: "",
    description: "Refunds",
    navFlow: NavFlow.FOCUS,
    title: "Refunds",
    parent: Tab.MORE,
  },
];

export const refunds: IMcAppType[] = refundsApp.flatMap((app) =>
  createRefundsMcApp(app)
);
